import ListCategoriesCommissions from './ListCategoriesCommissions'

export default ListCategoriesCommissions
